import styled from 'styled-components';

export const OpportunityContainer = styled.div`
  display: flex;
  justify-content: center;
  font-size: 12px;
  color: ${props => props.theme.colors.fontPrimary};
  line-height: 1.8;

  li {
    margin: 12px 0;
  }

  .content {
    max-width: 680px;
    @media screen and (max-width: 576px) {
      width: 100%;
    }
  }
`;

export const SectionTitle = styled.h4`
  font-weight: 600;
  font-size: 14px;
  line-height: 1.4;
  margin: 30px 0 5px 0;
`;

export const RequirementItem = styled.div`
  display: flex;
  gap: 8px;
  padding: 0;
  margin: 4px 0;
  align-items: center;
  font-family: 'Montserrat', sans-serif;

  li {
    margin: 10px 0;
  }
`;

export const OpportunityDescription = styled.pre`
  font-size: 12px;
  color: ${props => props.theme.colors.fontPrimary};
  font-family: 'Montserrat', sans-serif;
  white-space: break-spaces;
  line-height: 1.8;
`;